/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRemoteMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRemoteMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRemoteMcpServerSecurity = {
  option1?: GetRemoteMcpServerSecurityOption1 | undefined;
  option2?: GetRemoteMcpServerSecurityOption2 | undefined;
};

export type GetRemoteMcpServerRequest = {
  /**
   * The ID of the remote MCP server. Mutually exclusive with slug.
   */
  id?: string | undefined;
  /**
   * The slug of the remote MCP server. Mutually exclusive with id.
   */
  slug?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRemoteMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRemoteMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerSecurityOption1$Outbound,
  GetRemoteMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRemoteMcpServerSecurityOption1ToJSON(
  getRemoteMcpServerSecurityOption1: GetRemoteMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    GetRemoteMcpServerSecurityOption1$outboundSchema.parse(
      getRemoteMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRemoteMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerSecurityOption2$Outbound,
  GetRemoteMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRemoteMcpServerSecurityOption2ToJSON(
  getRemoteMcpServerSecurityOption2: GetRemoteMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    GetRemoteMcpServerSecurityOption2$outboundSchema.parse(
      getRemoteMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerSecurity$Outbound = {
  Option1?: GetRemoteMcpServerSecurityOption1$Outbound | undefined;
  Option2?: GetRemoteMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRemoteMcpServerSecurity$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerSecurity$Outbound,
  GetRemoteMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRemoteMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRemoteMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRemoteMcpServerSecurityToJSON(
  getRemoteMcpServerSecurity: GetRemoteMcpServerSecurity,
): string {
  return JSON.stringify(
    GetRemoteMcpServerSecurity$outboundSchema.parse(getRemoteMcpServerSecurity),
  );
}

/** @internal */
export type GetRemoteMcpServerRequest$Outbound = {
  id?: string | undefined;
  slug?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRemoteMcpServerRequest$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerRequest$Outbound,
  GetRemoteMcpServerRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    slug: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRemoteMcpServerRequestToJSON(
  getRemoteMcpServerRequest: GetRemoteMcpServerRequest,
): string {
  return JSON.stringify(
    GetRemoteMcpServerRequest$outboundSchema.parse(getRemoteMcpServerRequest),
  );
}
